<template>
  <project-template
    leftTitle="研究方向"
    :rightTitle="rightTitle"
    :nextBtnText="nextBtnText"
    @lastClick="lastClick"
    @nextClick="nextClick">
    <template v-slot:leftContent>
      <div v-if="viewKey === 'dept'">
        <div class="small-title">
          <img :src="require('@/assets/icon_department.png')" alt="">
          第一步：智能匹配科室
        </div>
        <div class="project-template2-card">
          <div
            v-if="deptSelectedList.length == 0"
            class="info-title info-title-center info-title-no"
          >
            您还没有添加科室
          </div>
          <template v-else>
            <div class="info-title info-title-dept" v-for="(item, index) in deptSelectedList" :key="index">
  <!--            <a-icon type="align-center" class="icon-big-dept"  />-->
              <img v-if="item.icon" :src="require('@/assets/icon/dept/'+item.icon+'.svg')" alt=""/>
              <br />
              <strong style="font-size: 18px">
                {{ item.name }}
              </strong>
            </div>
          </template>
        </div>
        <!-- <div class="q-tip" @click="viewKeyChange('dept')">
          <a-icon type="question-circle" />
          智能匹配结果不满意？选择其他推荐科室
          <a-icon type="right" style="margin-left: 20px" />
        </div> -->
      </div>
      <div v-if="viewKey === 'disease'">
        <div class="small-title">
          <img :src="require('@/assets/icon_sick.png')" alt="">
          第二步：智能匹配病种
        </div>
        <div class="project-template2-card">
          <div v-if="diseaseSelectedList.length == 0" class="info-title info-title-no" style="text-align: center;">
            您还没有添加病种
          </div>
          <template v-else>
            <div>
              <div class="info-mini-title">
                主病种
              </div>
              <template v-for="(item, index) in diseaseSelected1List">
                <!-- <div class="info-title info-title-disease1 " v-if="item.main" :key="index" @click="diseaseClick(item)"> -->
                <div class="info-title info-title-disease1 " v-if="item.main" :key="index">
                  <div style="text-align: center">
                    <a-icon type="align-center" class="icon-big" />
                    <div class="info-title-name">
                      <strong style="font-size: 18px">
                        {{ item.name }}
                      </strong>
                    </div>
                  </div>
                  <!-- <div class="module-names">
                    模块：{{ getModuleNames(item) }}
                  </div> -->
                </div>

              </template>
            </div>
            <div v-if="diseaseSelected2List.length > 0">
              <div class="info-mini-title">
                次病种
              </div>
              <template v-for="(item, index) in diseaseSelected2List">
                <!-- <div style="width:calc(100% - 20px);overflow-x: auto;" class="info-title2 " @click="diseaseClick(item)" :key="index"> -->
                <div style="width:calc(100% - 20px);overflow-x: auto;" class="info-title2 " :key="index">
                  <div :key="index" class="info-title-center">
                    <a-icon type="align-center" class="icon-big" />
                    <div class="info-title-name">
                      {{ item.name }}
                    </div>
                  </div>
                  <!-- <div class="module-names">
                    <label>模块数：</label>{{ getModuleLength(item) }}
                  </div> -->

                </div>
              </template>
            </div>

          </template>
        </div>

        <!-- <div class="q-tip" @click="viewKeyChange('disease')">
          <a-icon type="question-circle" />
          智能匹配结果不满意？选择其他推荐病种
          <a-icon type="right" style="margin-left: 20px" />
        </div> -->
      </div>
    </template>
    <template v-slot:rightContent>
      <dept :project="model" v-if="viewKey == 'dept'" @submit="loadProjectData"></dept>
      <disease ref="disease" :project="model" v-if="viewKey == 'disease'" @submit="loadProjectData"></disease>
    </template>
  </project-template>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import Dept from './projectTemplate2/Dept'
import Disease from './projectTemplate2/Disease'
import Module from './projectTemplate2/Module'
import ModuleForm from './projectTemplate2/ModuleForm'
import ModuleFormDiy from './projectTemplate2/ModuleFormDiy'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
export default {
  name: 'ProjectTemplate2',
  components: { ModuleFormDiy, ModuleForm, Module, Disease, Dept, ProjectTemplate },
  data() {
    return {
      rightTitle: '选择科室',
      model: {

      },
      deptSelectedList: [],
      diseaseSelectedList: [],
      viewKey: 'dept',
    }
  },
  computed: {
    nextBtnText(){
      if(this.viewKey === 'dept') return '下一步：选择病种';
      return '下一步：方案配置'
    },
    moduleJson() {
      if (this.model.moduleJson) {
        return JSON.parse(this.model.moduleJson)
      }
      return {}
    },
    diseaseSelected1List() {
      const result = []
      this.diseaseSelectedList.forEach(item => {
        if (item.main) {
          result.push(item)
        }
      })
      return result
    },
    diseaseSelected2List() {
      const result = []
      this.diseaseSelectedList.forEach(item => {
        if (!item.main) {
          result.push(item)
        }
      })
      return result
    }
  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    getModuleNames(disease) {
      let result = ''
      if (this.moduleJson[disease.code]) {
        this.moduleJson[disease.code].forEach((item, index) => {
          if (index < 3) {
            result += item.name + ','
          }
          if (index == 3) {
            result += '......' + ','
          }
        })
      }
      if (result) {
        result = result.substring(0, result.length - 1)
      }
      return result
    },
    getModuleLength(disease) {
      if (this.moduleJson[disease.code]) {
        return this.moduleJson[disease.code].length
      }
      return 0
    },
    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryById', { id }).then(res => {
        if (res.success) {
          this.model = res.result
          this.handleDept()
          this.handleDisease()
        }
      })
    },
    /**
     * 回显
     */
    handleDept() {
      this.deptSelectedList = JSON.parse(this.model.deptJson||'[]')
    },
    handleDisease() {
      this.diseaseSelectedList = JSON.parse(this.model.diseaseJson||'[]')
    },
    viewKeyChange(key) {
      this.viewKey = key
      if (key == 'disease') {
        this.$nextTick(() => {
          this.$refs.disease.backHandle()
        })
      }
    },
    createAuto() {
      this.$message.warning('一键生成方案暂未开发')
    },
    nextClick() {
      if (this.viewKey === 'dept') {
        if (this.deptSelectedList.length !== 0) {
          this.viewKey = 'disease';
          this.rightTitle = '选择病种';
        } else {
          this.$message.warning('请选择科室')
        }
      } else {
        if (this.diseaseSelectedList.length !== 0) {
          this.$emit('next')
        }else {
          this.$message.warning('请选择病种')
        }
      }
    },
    lastClick() {
      if (this.viewKey === 'dept') {
        this.$router.push({ path: '/pad/index' })
      } else {
        this.viewKey = 'dept';
        this.rightTitle = '选择科室';
      }
    },
    diseaseClick(item) {
      if (this.viewKey != 'disease') {
        this.viewKeyChange('disease')
      }
      this.$nextTick(() => {
        this.$refs.disease.itemClick(item)
      })
      this.rightTitle = '方案配置'
    }
  }
}
</script>

<style scoped lang="less">
.label {
  color: rgba(0, 0, 0, 0.5);
}

.project-template-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
}

.q-tip {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  padding: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 28px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.15);
}

.icon-big {
  font-size: 32px;
}

.info-title-name {
  margin-left: 10px;
}

.module-names {
  font-size: 12px;
  margin-left: 10px;
  margin-top: 10px;
}

.project-template2-card {
  overflow-x: auto;
  white-space: nowrap;
  //display: flex;
}

.info-title {
  height: 152px;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  color: white;
  background-color: #2f3b52;
}

.info-title-disease1 {
  padding-top: 20px;
  padding-bottom: 20px;
}

.info-title-center {
  text-align: center;
}

.info-title-dept {
  text-align: center;
}

.icon-big-dept {
  font-size: 32px;
}

.info-title-no {
  border: 1px dashed rgba(0, 0, 0, 0.2) !important;
}

.info-title2 {
  display: inline-table;
  width: 140px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #2f3b52;
  color: white;
  border-radius: 10px;
}

.info-mini-title {
  margin-top: 10px;
  margin-left: 10px;
  color: white;
}

.small-title {
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 21px;

  img {
    vertical-align: sub;
  }
}
</style>
